// components/VideoPlayer/WordInfoModal/ExternalDictBar.jsx

import React, { useMemo } from "react";
import "./WordInfoModal.css";

// لیست دیکشنری‌های خارجی بر اساس زبان
const EXTERNAL_DICTIONARIES = {
  // مشترک همه زبان‌ها
  common: [
    {
      name: "Bing",
      icon: "/icons/bing.png",
      url: (fromLang, toLang, word) =>
        `https://www.bing.com/translator/?from=${fromLang}&to=${toLang}&text=${word}`,
    },
    {
      name: "DeepL",
      icon: "/icons/deepl.png",
      url: (fromLang, toLang, word) =>
        `https://www.deepl.com/en/translator#${fromLang}/en-us/${word}`,
    },
    {
      name: "Glosbe",
      icon: "/icons/glosbe.png",
      url: (fromLang, toLang, word) =>
        `https://glosbe.com/${fromLang}/${toLang}/${word}`,
    },
    {
      name: "Google Translate",
      icon: "/icons/google.png",
      url: (fromLang, toLang, word) =>
        `https://translate.google.com/?sl=${fromLang}&tl=${toLang}&text=${word}&op=translate`,
    },
  ],

  // مختص انگلیسی
  en: [
    {
      name: "B-amooz",
      icon: "/icons/bamooz.png",
      url: (fromLang, toLang, word) =>
        `https://dic.b-amooz.com/${fromLang}/dictionary/w?word=${word}`,
    },
    {
      name: "Cambridge",
      icon: "/icons/cambridge.png",
      url: (fromLang, toLang, word) =>
        `https://dictionary.cambridge.org/dictionary/english/${word}`,
    },
    {
      name: "FastDic",
      icon: "/icons/fastdic.png",
      url: (fromLang, toLang, word) => `https://fastdic.com/word/${word}`,
    },
    {
      name: "Abadis",
      icon: "/icons/abadis.png",
      url: (fromLang, toLang, word) => `https://abadis.ir/entofa/${word}`,
    },
    {
      name: "Collins",
      icon: "/icons/collins.png",
      url: (fromLang, toLang, word) =>
        `https://www.collinsdictionary.com/dictionary/english/${word}`,
    },
  ],

  // مختص آلمانی
  de: [
    {
      name: "Collins DE",
      icon: "/icons/collins.png",
      url: (fromLang, toLang, word) =>
        `https://www.collinsdictionary.com/dictionary/german-english/${word}`,
    },
    {
      name: "B-amooz",
      icon: "/icons/bamooz.png",
      url: (fromLang, toLang, word) =>
        `https://dic.b-amooz.com/${fromLang}/dictionary/w?word=${word}`,
    },
  ],

  // مختص فرانسوی
  fr: [
    {
      name: "Collins FR",
      icon: "/icons/collins.png",
      url: (fromLang, toLang, word) =>
        `https://www.collinsdictionary.com/dictionary/french-english/${word}`,
    },
    {
      name: "B-amooz",
      icon: "/icons/bamooz.png",
      url: (fromLang, toLang, word) =>
        `https://dic.b-amooz.com/${fromLang}/dictionary/w?word=${word}`,
    },
  ],

  // مختص ایتالیایی
  it: [
    {
      name: "Collins IT",
      icon: "/icons/collins.png",
      url: (fromLang, toLang, word) =>
        `https://www.collinsdictionary.com/dictionary/italian-english/${word}`,
    },
    {
      name: "B-amooz",
      icon: "/icons/bamooz.png",
      url: (fromLang, toLang, word) =>
        `https://dic.b-amooz.com/${fromLang}/dictionary/w?word=${word}`,
    },
  ],

  // مختص ترکی
  tr: [
    {
      name: "B-amooz",
      icon: "/icons/bamooz.png",
      url: (fromLang, toLang, word) =>
        `https://dic.b-amooz.com/${fromLang}/dictionary/w?word=${word}`,
    },
  ],
};

const ExternalDictBar = ({ fromLang, toLang = "fa", word, onOpenPopup }) => {
  const dictionaries = useMemo(() => {
    // اگه fromLang معتبر نباشه، آرایه خالی برگردون
    if (!fromLang) return [];

    // دریافت دیکشنری مخصوص زبان
    const specific = EXTERNAL_DICTIONARIES[fromLang] || [];

    // دریافت دیکشنری‌های مشترک (با چک کردن اینکه تعریف شده باشه)
    const common = EXTERNAL_DICTIONARIES.common || [];

    //合并 آرایه‌ها
    const all = [...specific, ...common];

    // حذف موارد تکراری بر اساس name
    const unique = all.filter(
      (item, index, self) =>
        index === self.findIndex((t) => t.name === item.name),
    );

    return unique;
  }, [fromLang]);

  const handleClick = (dict) => {
    if (!word) return;

    const url = dict.url(fromLang, toLang, encodeURIComponent(word));

    // اطلاع به والد برای مدیریت فول‌اسکرین و حالت ویرایش
    if (onOpenPopup) {
      onOpenPopup();
    }

    // باز کردن پاپ‌آپ
    const width = 800;
    const height = 600;
    const left = window.screen.width / 2 - width / 2;
    const top = window.screen.height / 2 - height / 2;

    window.open(
      url,
      dict.name,
      `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`,
    );
  };

  // اگه دیکشنری‌ای نبود، چیزی نمایش نده
  if (dictionaries.length === 0) {
    return null;
  }

  return (
    <div className="wim-dictbar">
      <span className="wim-dictbar-label">
        <i className="fas fa-book"></i>
        دیکشنری‌ها
      </span>
      <span className="wim-dictbar-divider"></span>
      <div className="wim-dictbar-buttons">
        {dictionaries.map((dict, index) => (
          <button
            key={index}
            className="wim-dictbtn"
            onClick={() => handleClick(dict)}
            title={dict.name}
          >
            <img src={dict.icon} alt={dict.name} />
          </button>
        ))}
      </div>
    </div>
  );
};

export default ExternalDictBar;
